
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { PaymentTypes } from "~/operations/messages";
import { PaymentType } from "~/types/PaymentType";

@Component({
  components: {},
})
export default class DealerPaymentDetails extends Vue {
  @Prop({ required: true }) activePaymentType: PaymentType;
  @Prop({ default: [] }) availablePaymentTypes: Array<PaymentType>;

  get paymentTypeName() {
    return PaymentTypes[this.activePaymentType];
  }

  get paymentTypeImageUrl() {
    return `${process.env.PARTNER_MEDIA_CDN}/img/payment-types/${this.paymentTypeName}.svg`;
  }

  get availablePaymentTypeNames() {
    return this.availablePaymentTypes.map((type) => PaymentTypes[type]);
  }

  get otherPaymentTypeCount() {
    const count = this.availablePaymentTypes.filter(
      (val) => val !== "guaranteedPayment",
    ).length;

    return this.activePaymentType === "guaranteedPayment" ? count : count - 1;
  }

  get showGuaranteedPaymentInfo() {
    return (
      this.activePaymentType !== "guaranteedPayment" &&
      this.availablePaymentTypes.includes("guaranteedPayment")
    );
  }
}
